import { render } from "./SignInOtp.vue?vue&type=template&id=d66608f4&scoped=true&ts=true"
import script from "./SignInOtp.vue?vue&type=script&lang=ts"
export * from "./SignInOtp.vue?vue&type=script&lang=ts"

import "./SignInOtp.vue?vue&type=style&index=0&id=d66608f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d66608f4"]])

export default __exports__